import { AbstractControl } from '../abstract-control/AbstractControl';
import { PhoneService } from '../../../services/phone';

export class Input extends AbstractControl {
    query = {
        component: '.input',
        control: '.input__control',
    };

    states = {
        focused: 'input--focused',
        touched: 'input--touched',
        dirty: 'input--dirty',
        invalid: 'input--invalid',
        valid: 'input--valid',
        disabled: 'input--disabled',
    };
}

export class InputPhone extends Input {
    constructor(...args) {
        super(...args);

        this.phoneService = new PhoneService();

        this.control.placeholder = this.phoneService.getExample();
    }

    onInput() {
        super.onInput();

        this.control.value = this.phoneService.format(this.control.value);
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/modules/atoms/input/Input.js